const audioPath = 'https://interactive.thevisualagency.com/assets/dante/audio/';
const imagesPath = 'https://interactive.thevisualagency.com/assets/dante/images/';

export default {
    audioPath,
    imagesPath
}